'use client';

import * as React from 'react';

import { Color, ContentfulCollection, ContentfulModule } from 'libs/contentful/types';
import { Margins } from 'types/constants';

import { CardIconItem } from '../BaseCard/types';
import BaseCardCarousel from '../BaseCard/BaseCardCarousel';
import { liveUpdateAttrs } from 'libs/contentful/utils';

export interface CardsIconCarouselProps extends Omit<ContentfulModule, 'name'> {
  color: Color;
  cardStyle: string;
  cardIconItems: ContentfulCollection<CardIconItem>;
  margins: Margins;
  sectionName: string;

  testId?: string;
}

const CardsIconCarousel = ({
  sys,
  color,
  cardStyle,
  cardIconItems,
  margins,
  sectionName,
  testId,
}: CardsIconCarouselProps) => {
  const testFixture = testId ?? 'card-icon-carousel';

  return (
    <section
      {...(sectionName != null && { id: encodeURIComponent(sectionName) })}
      className="w-full"
      {...liveUpdateAttrs(sys?.id, 'content')}>
      <BaseCardCarousel
        cardItems={cardIconItems}
        color={color}
        margins={margins}
        cardStyle={cardStyle}
        testId={testFixture}
        sectionName={sectionName}
        sys={sys}
      />
    </section>
  );
};

export default CardsIconCarousel;
